import React from "react";
import { string, bool, func } from "prop-types";
import { SubscriptionDropdownCommon } from "..";
import type { DropdownOption } from "@/types";

type SubscriptionDropdownProps = {
  componentLabel?: string;
  defaultValue?: string;
  currentTeam?: string;
  required?: boolean;
  fullWidth?: boolean;
  onChange?: (event: string | DropdownOption) => void;
};

/**
 * Roles dropdown component
 * @param {object} props props
 * @returns {Element} React Component
 * @class
 */
export const SubscriptionDropdown = (props: SubscriptionDropdownProps) => {
  const handleChange = (
    event: React.ComponentProps<
      typeof SubscriptionDropdownCommon
    >["onChange"] extends (...args: infer Args) => unknown
      ? Args[0]
      : never,
  ) => {
    if (typeof props.onChange === "function") {
      props.onChange(event);
    }
  };

  const dropdownProps: React.ComponentProps<typeof SubscriptionDropdownCommon> =
    {
      componentLabel: props.componentLabel,
      defaultValue: props.defaultValue,
      visualStyle: "autoComplete",
      onChange: handleChange,
    };

  if (props.required) {
    dropdownProps.required = props.required;
  }
  if (typeof props.fullWidth !== "undefined") {
    (dropdownProps as any).fullWidth = props.fullWidth;
  }

  return <SubscriptionDropdownCommon {...dropdownProps} />;
};

SubscriptionDropdown.propTypes = {
  componentLabel: string,
  defaultValue: string,
  currentTeam: string,
  required: bool,
  onChange: func,
};
